import { render, staticRenderFns } from "./DatePickerV2.vue?vue&type=template&id=72422b1b&scoped=true&"
import script from "./DatePickerV2.vue?vue&type=script&lang=js&"
export * from "./DatePickerV2.vue?vue&type=script&lang=js&"
import style0 from "./DatePickerV2.vue?vue&type=style&index=0&id=72422b1b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72422b1b",
  null
  
)

export default component.exports